
export const ObjectTypeEnum = {
    Application: 1,
    Domain: 2,
    Course: 3,
    StudyGroup: 4,
    User: 5,
    Participant: 6,
    ToC: 7,
    Lesson: 8,
    Assessment: 9,
    Submission: 10,
    ContentBank: 11,
    UserGroup: 12,
    ConstUserGroup: 13,
    Project: 15,
    ProjectHistory: 16,
    Post: 17,
    External: 18
}

export const ObjectTypeEnumText = {
    Application: "Application",
    Domain: "Domain",
    Course: "Course",
    StudyGroup: "StudyGroup",
    User: "User",
    Participant: "Participant",
    ToC: "ToC",
    Lesson: "Lesson",
    Assessment: "Assessment",
    Submission: "Submission",
    ContentBank: "ContentBank",
    UserGroup: "UserGroup",
    ConstUserGroup: "ConstUserGroup",
    Project: "Project",
    ProjectHistory: "ProjectHistory",
    Post: "Post",
    External: "External"
};
